<template>
  <organism-idc-create-new-contract
    :customerOption="customerOption"
    :selectedCustomerDetail="selectedCustomerDetail"
    :businessTypeOption="businessTypeOption"
    :serviceOption="serviceOption"
    :locationOption="locationOption"
    :contactPointOption="contactPointOption"
    :saleOption="saleOption"
    :selectedContactPointId="selectedContactPointId"
    :selectedContactPointDetail="selectedContactPointDetail"
    :selectedSaleContactId="selectedSaleContactId"
    :selectedSaleContactDetail="selectedSaleContactDetail"
    :forceSelectedCustomer="forceSelectedCustomer"
    :funcGetPackageNameList="getPackageNameListByServiceIdFromApi"
    :funcGetServiceAndPackageDetail="getServiceAndPackageDetailByIdFromApi"
    :escalation-template-list="escalationTemplateList"
    :escalation="escalation"
    :escalation-detail="escalationDetail"
    @onChangeEscalationTemplate="onChangeEscalationTemplate"
    @onSelectCustomer="onSelectCustomer"
    @onUpdateOptionalContractId="onUpdateOptionalContractId"
    @onAddNewCustomer="onAddNewCustomer"
    @onSelectService="onSelectService"
    @onSelectPackage="onSelectPackage"
    @onSelectContactPoint="onSelectContactPoint"
    @onClearSelectedContactPointId="onClearSelectedContactPointId"
    @onSelectSaleContact="onSelectSaleContact"
    @onClearSelectedSaleContactId="onClearSelectedSaleContactId"
    @onCreateNewContract="onCreateNewContract"
    @onRequestCreateNewContactPoint="onRequestCreateNewContactPoint"
    @onUpdateContactPointProfilePicture="onUpdateContactPointProfilePicture"
    @onRequestCreateNewSaleContact="onRequestCreateNewSaleContact"
    @onUpdateSaleProfilePicture="onUpdateSaleProfilePicture"
    @onSelectSite="onSelectSite"
  ></organism-idc-create-new-contract>
</template>

<script>
import OrganismIdcCreateNewContract from "@/components/organisms/portal/internal/idc/OrganismIdcCreateNewContract.vue"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import {
  getCustomerNameList,
  getCustomerDetailById,
  getBusinessTypeList,
  getServicesName,
  createNewCustomer,
  getContactPointAndSaleNameList,
  getPackageNameListByServiceId,
  getServiceAndPackageDetailById,
  getLocationList,
  getContactPointOrSaleDetailById,
  createNewContactPointOrSale,
  updateProfilePicture,
  createNewContract,
} from "@/api/api-module1"
import {
  getTicketEscalationActiveList,
  getTicketEscalationById,
} from "@/api/module-1/escalation"

export default {
  name: "IdcCreateNewContract",
  components: { OrganismIdcCreateNewContract },
  mixins: [mixins, mixinsValidator],
  data() {
    return {
      currentContactPointProfilePicture: null,
      currentSaleProfilePicture: null,
      customerOption: [],
      businessTypeOption: [],
      serviceOption: [],
      saleOption: [],
      contactPointOption: [],
      locationOption: [],
      selectedCustomerId: null,
      selectedCustomerDetail: {},
      selectedContactPointId: null,
      selectedContactPointDetail: {},
      selectedSaleContactId: null,
      selectedSaleContactDetail: {},
      forceSelectedCustomer: {},
      optionalContractId: null,
      escalationTemplateList: [],
      escalation: null,
      escalationDetail: {
        name: "",
        description: "",
        levels: [],
      },
    }
  },
  async mounted() {
    await this.getTicketEscalationActiveList()
    await this.getCustomerNameListFromApi()
    await this.getBusinessTypeListFromApi()
    await this.getServiceListFromApi()
    await this.getContactPointAndSaleNameListFromApi()
  },
  methods: {
    async getTicketEscalationActiveList() {
      this.showLoading(true)
      await getTicketEscalationActiveList()
        .then((response) => {
          this.escalationTemplateList = response.data
        })
        .finally(() => this.showLoading(false))
    },

    async getCustomerNameListFromApi() {
      await getCustomerNameList().then((response) => {
        this.customerOption = response
      })
    },

    async getCustomerDetailFromApi(customerId) {
      this.showLoading(true)
      await getCustomerDetailById(customerId)
        .then((response) => {
          this.selectedCustomerDetail = response.data
          this.mapSelectedCustomerDetailData()
        })
        .finally(() => this.showLoading(false))
    },

    async getBusinessTypeListFromApi() {
      this.showLoading(true)
      await getBusinessTypeList()
        .then((response) => {
          if (response) {
            this.businessTypeOption = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getServiceListFromApi() {
      this.showLoading(true)
      await getServicesName()
        .then((response) => {
          if (response) {
            this.serviceOption = response
          }
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestCreateNewCustomer(customerData) {
      this.showLoading(true)
      let newCustomerId = null
      await createNewCustomer(customerData)
        .then(async (response) => {
          if (response) {
            newCustomerId = response.data
            this.toastSuccess("Create New Customer Successfully")
          }
          await this.getCustomerNameListFromApi()
          await this.getCustomerDetailFromApi(newCustomerId)
        })
        .catch((error) => {
          if (error.response.data) {
            this.toastError(error.response.data.ErrorMessage)
          } else {
            this.toastError("Create New Customer Failed")
          }
        })
      this.showLoading(false)
    },

    async getContactPointAndSaleNameListFromApi() {
      this.showLoading(true)
      await getContactPointAndSaleNameList()
        .then((response) => {
          if (response) {
            this.saleOption = response.data.filter(
              (data) => data.contactType.toLowerCase() === "sale"
            )
            this.contactPointOption = response.data.filter(
              (data) => data.contactType.toLowerCase() === "customer"
            )
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getPackageNameListByServiceIdFromApi(serviceId) {
      return await getPackageNameListByServiceId(serviceId)
    },

    async getServiceAndPackageDetailByIdFromApi(serviceId, packageId) {
      return await getServiceAndPackageDetailById(serviceId, packageId)
    },

    async getLocationListFromApi(selectedSite) {
      const params = {
        siteId: selectedSite?.siteId ? selectedSite.siteId : undefined,
      }
      await getLocationList(params).then((response) => {
        if (response) {
          this.locationOption = response.data
        }
      })
    },

    async getContactPointDetailByIdFromApi(selectedContactPointId) {
      await getContactPointOrSaleDetailById(selectedContactPointId).then(
        (response) => {
          if (response) {
            this.selectedContactPointDetail = response.data
          }
        }
      )
    },

    async getSaleDetailByIdFromApi(selectedSaleId) {
      await getContactPointOrSaleDetailById(selectedSaleId).then((response) => {
        if (response) {
          this.selectedSaleContactDetail = response.data
        }
      })
    },

    async onAddNewCustomer(newCustomerData) {
      const customerData = this.decorateCustomerDataToApi(newCustomerData)
      await this.sendRequestCreateNewCustomer(customerData)
    },

    async sendRequestCreateNewContractApi(newContractDetail) {
      this.showLoading(true)
      await createNewContract(newContractDetail)
        .then((response) => {
          this.showLoading(true)
          if (response.data) {
            this.toastSuccess("Create Successfully")
            this.showLoading(false)
            const ntdcId = response.data
              ? response.data.toString().padStart(8, "0")
              : null
            if (ntdcId) {
              this.navigateTo("/internal/web-portal/idc/contract/" + ntdcId)
            } else {
              this.navigateTo("/internal/web-portal/idc")
            }
          }
          this.showLoading(false)
        })
        .catch((error) => {
          if (error.response.data.Message === "ContractId already exist") {
            this.toastError("Duplicate Optional Contract ID")
          } else {
            this.toastError("Create Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async createNewContactPointApi(newContactPointData) {
      this.showLoading(true)
      await createNewContactPointOrSale(newContactPointData)
        .then((response) => {
          if (response) {
            this.getContactPointAndSaleNameListFromApi()
            this.selectedContactPointId = response.data
            this.toastSuccess("Create Contact Point/Sale Successfully")
            if (this.currentContactPointProfilePicture) {
              const contactId = response.data
              this.updateContactPointProfilePictureApi(contactId)
            }
          } else {
            this.toastError("Create Contact Point/Sale Failed")
            this.currentContactPointProfilePicture = null
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateContactPointProfilePictureApi(contactId) {
      this.showLoading(true)
      await updateProfilePicture(
        this.currentContactPointProfilePicture,
        contactId
      )
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Profile Picture Successfully")
          } else {
            this.toastError("Update Profile Picture Failed")
          }
          this.currentContactPointProfilePicture = null
        })
        .finally(() => this.showLoading(false))
    },

    async createNewSaleContactApi(newSaleData) {
      this.showLoading(true)
      await createNewContactPointOrSale(newSaleData)
        .then((response) => {
          if (response) {
            this.getContactPointAndSaleNameListFromApi()
            this.selectedSaleContactId = response.data
            this.toastSuccess("Create Contact Point/Sale Successfully")
            if (this.currentSaleProfilePicture) {
              const contactId = response.data
              this.updateSaleProfilePictureApi(contactId)
            }
          } else {
            this.toastError("Create Contact Point/Sale Failed")
            this.currentSaleProfilePicture = null
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateSaleProfilePictureApi(contactId) {
      this.showLoading(true)
      await updateProfilePicture(this.currentSaleProfilePicture, contactId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Profile Picture Successfully")
          } else {
            this.toastError("Update Profile Picture Failed")
          }
          this.currentSaleProfilePicture = null
        })
        .finally(() => this.showLoading(false))
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    async onChangeEscalationTemplate(escalationSelected) {
      this.escalation = escalationSelected
      this.escalationDetail = {
        name: "",
        description: "",
        levels: [],
      }

      if (this.escalation?.escalationId) {
        await this.getEscalationDetail(this.escalation?.escalationId)
      }
    },

    async getEscalationDetail(escalationId) {
      this.showLoading(true)
      await getTicketEscalationById(escalationId)
        .then((response) => {
          this.escalationDetail = response
        })
        .finally(() => this.showLoading(false))
    },

    onSelectCustomer(customerId) {
      if (customerId) {
        this.getCustomerDetailFromApi(customerId)
      } else {
        this.selectedCustomerDetail = {}
      }
    },

    onUpdateOptionalContractId(isUseOptionalContractId, optionalContractId) {
      if (isUseOptionalContractId) {
        this.optionalContractId = optionalContractId
      } else {
        this.optionalContractId = null
      }
    },

    onSelectSite(selectedSite) {
      this.getLocationListFromApi(selectedSite)
    },

    onSelectContactPoint(selectedContactPoint) {
      const contactPointId = selectedContactPoint.contactPointId
      this.getContactPointDetailByIdFromApi(contactPointId)
    },

    onClearSelectedContactPointId() {
      this.selectedContactPointId = null
    },

    onSelectSaleContact(selectedSale) {
      const saleId = selectedSale.contactPointId
      this.getSaleDetailByIdFromApi(saleId)
    },

    onClearSelectedSaleContactId() {
      this.selectedSaleContactId = null
    },

    onSelectService(selectedService) {
      this.getPackageNameListByServiceIdFromApi(selectedService.serviceId)
    },

    onSelectPackage(selectedPackage, selectedService) {
      this.getServiceAndPackageDetailByIdFromApi(
        selectedService.serviceId,
        selectedPackage.packageId
      )
    },

    onCreateNewContract(newContractDetail) {
      const newContract = this.decorateContractDataToApi(newContractDetail)
      this.sendRequestCreateNewContractApi(newContract)
    },

    decorateContractDataToApi(contractDetail) {
      const contactPointsList = contractDetail.contactPoints.map((item) => {
        if (item.hasOwnProperty("contactId")) {
          return {
            contactPointId: item.contactId,
            contactPointEmailId: item.contactEmailId,
            contactPointPhoneId: item.contactPhoneId,
            contactPointAccessCard: item.contactAccessCard,
          }
        } else {
          return item
        }
      })
      const saleContactList = contractDetail.saleContact.map((item) => {
        if (item.hasOwnProperty("contactId")) {
          return {
            contactPointId: item.contactId,
            contactPointEmailId: item.contactEmailId,
            contactPointPhoneId: item.contactPhoneId,
            contactPointAccessCard: item.contactAccessCard,
          }
        } else {
          return item
        }
      })
      return {
        contractId: this.optionalContractId
          ? this.optionalContractId.replace(/\D/g, "")
          : null,
        additionalIds: contractDetail.additionalIds,
        customerId: contractDetail.customer.customerId,
        packages: contractDetail.packages.map((item) => {
          return {
            serviceId: item.serviceId,
            packageId: item.packageId,
            packageQuantity: item.packageQuantity,
            packagePeriodId: item.packagePeriodId,
            locationId: item.locationId,
            bundleNetwork: item.bundleNetwork,
            domain: item.domain,
            rack: item.rack,
            serviceNote: item.serviceNote,
            packageOptions: item.packageOptions,
            startDate: item.startDate,
            endDate: item.endDate,
          }
        }),
        siteId: contractDetail.generalServiceInfo.siteId,
        otherTechnicalDetail:
          contractDetail.generalServiceInfo.otherTechnicalDetail,
        contactPoints: [...contactPointsList, ...saleContactList],
        notes: this.hasString(contractDetail.notes)
          ? [contractDetail.notes]
          : [],
        startDate: contractDetail.generalServiceInfo.contractStartDate,
        endDate: null,
        escalationId: this.escalation?.escalationId,
      }
    },

    onRequestCreateNewSaleContact(newSaleContactDetail) {
      const newSaleContactDataToApi =
        this.decorateNewSaleContactDetailDataToApi(newSaleContactDetail)
      this.createNewSaleContactApi(newSaleContactDataToApi)
      this.getContactPointAndSaleNameListFromApi()
    },

    onRequestCreateNewContactPoint(contactPointDetail) {
      const newContactPointDataToApi =
        this.decorateNewContactPointDetailDataToApi(contactPointDetail)
      this.createNewContactPointApi(newContactPointDataToApi)
      this.getContactPointAndSaleNameListFromApi()
    },

    mapSelectedCustomerDetailData() {
      this.selectedCustomerDetail.mainAddress.businessType =
        this.businessTypeOption.find(
          (businessType) =>
            businessType.businessTypeId ===
            this.selectedCustomerDetail.mainAddress.businessTypeId
        )
      this.selectedCustomerDetail.billingAddress.businessType =
        this.businessTypeOption.find(
          (businessType) =>
            businessType.businessTypeId ===
            this.selectedCustomerDetail.billingAddress.businessTypeId
        )
      this.selectedCustomerDetail.mailingAddress.businessType =
        this.businessTypeOption.find(
          (businessType) =>
            businessType.businessTypeId ===
            this.selectedCustomerDetail.mailingAddress.businessTypeId
        )
      this.selectedCustomerDetail.billingAddress.vat =
        this.selectedCustomerDetail.billingAddress.vatType
    },

    decorateNewContactPointDetailDataToApi(contactPointDetail) {
      const contactPointDataToApi = {
        contactType: "CUSTOMER",
        firstname: contactPointDetail.firstName,
        lastname: contactPointDetail.lastName,
        idType: contactPointDetail.idType,
        identification: contactPointDetail.idOrPassportNumber,
        emails: this.getEmailList(contactPointDetail),
        phones: this.getPhoneList(contactPointDetail),
        accesses: this.getAccessList(contactPointDetail),
      }
      return contactPointDataToApi
    },

    decorateNewSaleContactDetailDataToApi(newSaleContactDetail) {
      const saleDataToApi = {
        contactType: "SALE",
        firstname: newSaleContactDetail.firstName,
        lastname: newSaleContactDetail.lastName,
        idType: newSaleContactDetail.idType,
        identification: newSaleContactDetail.idOrPassportNumber,
        emails: this.getEmailList(newSaleContactDetail),
        phones: this.getPhoneList(newSaleContactDetail),
        accesses: [],
      }
      return saleDataToApi
    },

    getEmailList(contactDetail) {
      let emailList = [
        contactDetail.email.primary,
        contactDetail.email.secondary,
        contactDetail.email.third,
      ]
      emailList = emailList.filter((email) => email.email)
      let uniqueEmailList = emailList.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.email === value.email)
      )
      return uniqueEmailList
    },

    getPhoneList(contactDetail) {
      let phoneList = [
        contactDetail.phone.primary,
        contactDetail.phone.secondary,
        contactDetail.phone.third,
      ]
      phoneList = phoneList.filter((phone) => phone.phone)
      let uniquePhoneList = phoneList.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.phone === value.phone)
      )
      return uniquePhoneList
    },

    getAccessList(contactDetail) {
      return contactDetail.accesses.map((access) => {
        return {
          contactPointAccessId: access.contactPointAccessId,
          accessCardNumber: access.accessCardNumber,
          locationId: access.locationId,
        }
      })
    },

    onUpdateContactPointProfilePicture(newProfilePicture) {
      this.currentContactPointProfilePicture = newProfilePicture
    },

    onUpdateSaleProfilePicture(newProfilePicture) {
      this.currentSaleProfilePicture = newProfilePicture
    },

    decorateCustomerDataToApi(customerData) {
      return {
        customerName: customerData.name,
        mainAddress: {
          organizationName: customerData.mainAddress.organizationName,
          businessTypeId: customerData.mainAddress.businessType.businessTypeId,
          email: customerData.mainAddress.email,
          phone: customerData.mainAddress.phone,
          fax: customerData.mainAddress.fax,
          country: customerData.mainAddress.country,
          province:
            customerData.mainAddress.province.name_th ??
            customerData.mainAddress.province,
          district:
            customerData.mainAddress.district.name_th ??
            customerData.mainAddress.district,
          subDistrict:
            customerData.mainAddress.subDistrict.name_th ??
            customerData.mainAddress.subDistrict,
          address: customerData.mainAddress.address,
          postalCode: customerData.mainAddress.postalCode,
        },
        billingAddress: {
          organizationName: customerData.billingAddress.organizationName,
          businessTypeId:
            customerData.billingAddress.businessType.businessTypeId,
          email: customerData.billingAddress.email,
          phone: customerData.billingAddress.phone,
          fax: customerData.billingAddress.fax,
          country: customerData.billingAddress.country,
          province:
            customerData.billingAddress.province.name_th ??
            customerData.billingAddress.province,
          district:
            customerData.billingAddress.district.name_th ??
            customerData.billingAddress.district,
          subDistrict:
            customerData.billingAddress.subDistrict.name_th ??
            customerData.billingAddress.subDistrict,
          address: customerData.billingAddress.address,
          postalCode: customerData.billingAddress.postalCode,
          vatType: customerData.billingAddress.vat,
        },
        mailingAddress: {
          organizationName: customerData.mailingAddress.organizationName,
          businessTypeId:
            customerData.mailingAddress.businessType.businessTypeId,
          email: customerData.mailingAddress.email,
          phone: customerData.mailingAddress.phone,
          fax: customerData.mailingAddress.fax,
          country: customerData.mailingAddress.country,
          province:
            customerData.mailingAddress.province.name_th ??
            customerData.mailingAddress.province,
          district:
            customerData.mailingAddress.district.name_th ??
            customerData.mailingAddress.district,
          subDistrict:
            customerData.mailingAddress.subDistrict.name_th ??
            customerData.mailingAddress.subDistrict,
          address: customerData.mailingAddress.address,
          postalCode: customerData.mailingAddress.postalCode,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
